import React, { useState, useRef, useEffect } from 'react';
import styles from './LandingHeader.module.css';

const SSO_APPLICATIONS_URL =
  'https://sso.drive-news.de/realms/drive/account/applications';
const DRIVEMIXER_DASHBOARD_URL = 'https://drivemixer.drive-news.de/dashboard';
const DRIVELOCAL_DASHBOARD_URL = 'https://drivelocal.drive-news.de/erste-schritte';

function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default function LandingHeader({ 
  logoUrl, 
  faviconUrl, 
  homeHref = '/',
  isAuthenticated = false,
  user = null,
  handleLogout,
  currentTabCopy,
  isScrolled = false
}) {
  const [appSwitcherOpen, setAppSwitcherOpen] = useState(false);
  const appSwitcherRef = useRef(null);

  useEffect(() => {
    const onDocMouseDown = (e) => {
      if (appSwitcherRef.current && !appSwitcherRef.current.contains(e.target)) {
        setAppSwitcherOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocMouseDown);
    return () => document.removeEventListener('mousedown', onDocMouseDown);
  }, []);

  useEffect(() => {
    if (!appSwitcherOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setAppSwitcherOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [appSwitcherOpen]);

  useEffect(() => {
    if (!isAuthenticated || !user) setAppSwitcherOpen(false);
  }, [isAuthenticated, user]);

  const showAppSwitcher = Boolean(isAuthenticated && user);

  return (
    <nav className={cx(styles.landingNav, isScrolled && styles.landingNavScrolled)} aria-label="Hauptnavigation">
      <div className={styles.appSwitcherHostOuter}>
        <div ref={appSwitcherRef} className={styles.appSwitcherHost}>
        <a
          href={homeHref}
          className={styles.logoLink}
          aria-label="Leuchtturm Metrik Startseite"
        >
          <img src={logoUrl} alt="" className={styles.logoImg} />
          <span className="logo-text">CONSOLE</span>
        </a>
        {showAppSwitcher && (
          <>
            <button
              type="button"
              className={styles.appSwitcherBtn}
              aria-expanded={appSwitcherOpen}
              aria-haspopup="menu"
              aria-label="App wechseln"
              onClick={() => setAppSwitcherOpen((v) => !v)}
            >
              <svg
                className={cx(
                  styles.appSwitcherChevron,
                  appSwitcherOpen && styles.appSwitcherChevronOpen
                )}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>

            <div
              className={cx(
                styles.appSwitcherPanel,
                appSwitcherOpen ? styles.appSwitcherOpen : styles.appSwitcherClosed
              )}
              role="menu"
              aria-label="Weitere Drive-Apps"
            >
              <a
                role="menuitem"
                href={DRIVEMIXER_DASHBOARD_URL}
                className={styles.appSwitcherItem}
                onClick={() => setAppSwitcherOpen(false)}
              >
                <img src={logoUrl} alt="" className={styles.appSwitcherImg} />
                <span className={styles.appSwitcherWordmark}>MIXER</span>
              </a>
              <a
                role="menuitem"
                href={DRIVELOCAL_DASHBOARD_URL}
                className={styles.appSwitcherItem}
                onClick={() => setAppSwitcherOpen(false)}
              >
                <img src={logoUrl} alt="" className={styles.appSwitcherImg} />
                <span className={styles.appSwitcherWordmark}>LOCAL</span>
              </a>
            </div>
          </>
        )}

        {isAuthenticated && currentTabCopy && (
          <div className={styles.headerContext}>
            <span className={styles.headerKicker}>{currentTabCopy.kicker}</span>
            <span className={styles.headerDot} aria-hidden="true"></span>
            <span className={styles.headerSection}>{currentTabCopy.title}</span>
          </div>
        )}
      </div>

        <div className={styles.landingNavActions}>
          <a
            href={SSO_APPLICATIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.ssoIconLink}
            title="Drive-Konto & Anwendungen"
          >
            <img src={faviconUrl} alt="" className={styles.ssoIcon} />
          </a>

          {isAuthenticated ? (
            user ? (
              <div className={styles.userInfo}>
                <span>{user.name}</span>
                <button type="button" onClick={handleLogout} className={styles.logoutBtn}>
                  Abmelden
                </button>
              </div>
            ) : null
          ) : (
            <a href="#anmeldung" className={styles.btnOutlineMarketing}>
              Anmelden
            </a>
          )}
        </div>
      </div>
    </nav>
  );
}
